/**
 * Detect whether ads are running in test mode.
 * Returns true when test/placeholder ad IDs are in use,
 * so analytics events can be suppressed for test impressions.
 */

const GOOGLE_TEST_PREFIX = 'ca-app-pub-3940256099942544';

export function isTestAdEnvironment() {
    // Development mode is always test
    if (process.env.NODE_ENV === 'development') return true;

    const platform = window.Capacitor?.getPlatform?.() || 'web';

    if (platform === 'web') {
        // Placeholder or missing AdSense client means no real ads
        const client = process.env.REACT_APP_ADSENSE_CLIENT || '';
        if (!client || client.includes('XXXX')) return true;
        return false;
    }

    // Native: check if the ad unit IDs are Google's demo test IDs
    if (platform === 'ios') {
        const banner = process.env.REACT_APP_ADMOB_BANNER_ID_IOS || '';
        const rewarded = process.env.REACT_APP_ADMOB_REWARDED_ID_IOS || '';
        if (banner.startsWith(GOOGLE_TEST_PREFIX) || rewarded.startsWith(GOOGLE_TEST_PREFIX)) return true;
    } else if (platform === 'android') {
        const banner = process.env.REACT_APP_ADMOB_BANNER_ID_ANDROID || '';
        const rewarded = process.env.REACT_APP_ADMOB_REWARDED_ID_ANDROID || '';
        if (banner.startsWith(GOOGLE_TEST_PREFIX) || rewarded.startsWith(GOOGLE_TEST_PREFIX)) return true;
    }

    // Also check emulator
    const ua = navigator.userAgent || '';
    if (/sdk_gphone|Emulator|Android SDK|google_sdk|Simulator/i.test(ua)) return true;

    return false;
}
